import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDatasource14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    role="img"
    {...props}
  >
    <path
      fill="#666"
      fillRule="evenodd"
      d="M7 0c2.73 0 5 1.008 5 2.5 0 .046-.002.09-.006.135l.006.008v7.714C12 11.917 9.728 13 7 13c-2.54 0-4.691-.94-4.972-2.362l-.021-.144L2 10.357V2.643l.006-.007L2 2.5C2 1.055 4.13.064 6.745.003L7 0Zm4 4.041a5.019 5.019 0 0 1-1.218.561l-.362.105c-.17.045-.345.085-.526.12l-.325.056a9.784 9.784 0 0 1-.861.094l-.31.016L7 5l-.398-.007-.31-.016a10.05 10.05 0 0 1-.58-.055l-.331-.047a8.523 8.523 0 0 1-.542-.104l-.296-.074-.038-.01C3.92 4.527 3.406 4.309 3 4.042v6.289l.003.083C3.088 11.211 4.826 12 7 12c2.163 0 3.874-.778 3.993-1.556l.007-.087V4.041ZM7 1c-2.16 0-3.874.727-3.993 1.423L3 2.5l.005.064c.028.175.153.35.358.516l.14.104.111.07a4.49 4.49 0 0 0 1.05.436l.178.05.213.051.336.068a9.38 9.38 0 0 0 3.218 0l.17-.032.166-.036a6.55 6.55 0 0 0 .213-.052l.178-.05a4.49 4.49 0 0 0 1.05-.435l.143-.092c.23-.162.384-.335.444-.51l.022-.088L11 2.5C11 1.782 9.24 1 7 1Z"
    />
  </svg>
);
const Memo = memo(SvgDatasource14Px);
export default Memo;
